export const RETURN_URL_PARAM = "returnURL";

export const BACKGROUND_GRADIENTS = [
    "from-red-100 via-rose-200 to-green-300",
    "from-blue-100 via-indigo-200 to-purple-300",
    "from-yellow-100 via-amber-200 to-orange-300",
    "from-pink-100 via-purple-200 to-blue-300",
    "from-green-100 via-emerald-200 to-teal-300",
    "from-purple-100 via-violet-200 to-pink-300",
    "from-indigo-100 via-blue-200 to-cyan-300",
    "from-orange-100 via-red-200 to-red-300",
    "from-teal-100 via-cyan-200 to-green-300",
    "from-cyan-100 via-sky-200 to-blue-300",
    "from-rose-100 via-pink-200 to-pink-300",
    "from-amber-100 via-orange-200 to-yellow-300",
    "from-lime-100 via-green-200 to-green-300",
    "from-emerald-100 via-teal-200 to-teal-300",
    "from-sky-100 via-blue-200 to-indigo-300",
    "from-violet-100 via-purple-200 to-purple-300",
    "from-fuchsia-100 via-pink-200 to-pink-300",
    "from-slate-100 via-zinc-200 to-gray-300",
    "from-red-200 via-purple-400 to-blue-600",
    "from-purple-200 via-pink-400 to-orange-600",
    "from-green-200 via-teal-400 to-pink-600",
    "from-blue-200 via-purple-400 to-red-600",
    "from-yellow-200 via-orange-400 to-purple-600",
    "from-pink-200 via-rose-400 to-green-600",
    "from-cyan-200 via-blue-400 to-orange-600",
    "from-indigo-200 via-purple-400 to-yellow-600",
    "from-orange-300 via-red-500 to-blue-700",
    "from-teal-300 via-cyan-500 to-pink-700",
    "from-violet-300 via-purple-500 to-green-700",
    "from-rose-300 via-pink-500 to-cyan-700",
    "from-amber-300 via-orange-500 to-indigo-700",
    "from-emerald-300 via-teal-500 to-purple-700",
    "from-sky-300 via-blue-500 to-orange-700",
    "from-fuchsia-300 via-purple-500 to-teal-700",
    "from-lime-400 via-green-600 to-purple-800",
    "from-red-400 via-pink-600 to-cyan-800",
    "from-blue-400 via-indigo-600 to-yellow-800",
    "from-green-400 via-emerald-600 to-pink-800",
    "from-purple-400 via-violet-600 to-orange-800",
    "from-orange-400 via-red-600 to-blue-900",
    "from-pink-400 via-rose-600 to-green-900",
    "from-cyan-400 via-blue-600 to-red-900"
];

export const HOLIDAY_BACKGROUND_GRADIENTS = {
    christmas: [
        "from-red-500 to-green-600",
        "from-green-400 to-red-600",
        "from-red-300 to-green-700",
        "from-emerald-400 to-red-500",
        "from-red-400 to-emerald-600"
    ],
    halloween: [
        "from-orange-500 to-black",
        "from-purple-600 to-orange-600",
        "from-black to-orange-500",
        "from-orange-400 to-purple-800",
        "from-amber-500 to-slate-900"
    ],
    valentine: [
        "from-pink-400 to-red-600",
        "from-red-400 to-pink-600",
        "from-rose-300 to-red-700",
        "from-pink-300 to-rose-700",
        "from-red-300 to-pink-700"
    ],
    stpatrick: [
        "from-green-400 to-emerald-700",
        "from-emerald-300 to-green-800",
        "from-lime-400 to-green-700",
        "from-green-300 to-teal-700",
        "from-emerald-200 to-green-900"
    ],
    independence: [
        "from-red-500 via-white to-blue-700",
        "from-blue-400 via-white to-red-600",
        "from-red-300 via-white to-blue-800",
        "from-blue-300 via-white to-red-700",
        "from-red-400 via-white to-blue-600"
    ],
    thanksgiving: [
        "from-orange-300 to-red-800",
        "from-amber-300 to-orange-900",
        "from-yellow-300 to-red-900",
        "from-orange-200 to-amber-900",
        "from-yellow-200 to-orange-900"
    ],
    newyear: [
        "from-purple-900 to-yellow-500",
        "from-indigo-900 to-amber-400",
        "from-slate-800 to-yellow-400",
        "from-violet-900 to-gold",
        "from-purple-800 to-white"
    ],
    easter: [
        "from-pink-300 to-yellow-400",
        "from-purple-300 to-pink-500",
        "from-yellow-300 to-pink-600",
        "from-violet-300 to-yellow-500",
        "from-pink-200 to-purple-500"
    ],
    420: [
        "from-green-400 to-purple-800",
        "from-lime-300 to-green-900",
        "from-emerald-300 to-black",
        "from-green-300 to-purple-900",
        "from-lime-400 to-slate-900"
    ]
};
